import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'sm' | 'md' | 'lg';
  shadow?: 'sm' | 'md' | 'lg' | 'xl';
  rounded?: 'sm' | 'md' | 'lg' | 'xl';
  onClick?: () => void;
}

/**
 * 通用卡片组件
 * 支持悬停效果、不同的内边距、阴影和圆角设置
 */
const Card: React.FC<CardProps> = ({ children, className = '', hover = false, ...props }) => {
  const baseClasses = 'bg-white rounded-2xl shadow-sm border border-gray-100 backdrop-blur-sm';
  const hoverClasses = hover ? 'card-hover cursor-pointer' : '';
  
  return (
    <div 
      className={`${baseClasses} ${hoverClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export { Card };